// شناسه‌های کلاینت آفلاین: client_operation_id با UUIDv7 (ARD-offline §۲) و شناسه دستگاه برای شماره موقت OFF-{device}-{seq} (BR-BIL-023).
import type { OfflineStore } from './store';

/** UUIDv7 (۴۸ بیت زمان میلی‌ثانیه + تصادفی). */
export function uuidv7(now: number = Date.now()): string {
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
  let time = now;
  for (let index = 5; index >= 0; index -= 1) {
    bytes[index] = time % 256;
    time = Math.floor(time / 256);
  }
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x70;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = [...bytes].map((value) => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

const DEVICE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

/** کد دستگاه ۸ نویسه‌ای (حروف و رقم بزرگ؛ الگوی سرور ^[A-Z0-9]{4,12}$). */
export function newDeviceCode(): string {
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(8));
  return [...bytes].map((value) => DEVICE_ALPHABET[value % DEVICE_ALPHABET.length]).join('');
}

/** شماره موقت چاپی هم‌قالب سرور (InvoiceNumbering.Provisional). */
export function provisionalNumber(device: string, sequence: number): string {
  return `OFF-${device}-${String(sequence).padStart(6, '0')}`;
}

const DEVICE_KEY = 'device';
const SEQUENCE_KEY = 'sequence';

/**
 * شناسه دستگاه و شمارنده شماره موقت در Store «meta» (بدون داده مستأجر؛ با خروج پاک نمی‌شود تا شماره موقت دستگاه تکرار نشود — C-AGENT-1552).
 */
export async function deviceId(store: OfflineStore): Promise<string> {
  const existing = await store.get<string>('meta', DEVICE_KEY);
  if (existing && /^[A-Z0-9]{4,12}$/.test(existing)) {
    return existing;
  }
  const created = newDeviceCode();
  await store.put('meta', DEVICE_KEY, created);
  return created;
}

/** شمارنده بعدی شماره موقت دستگاه. */
export async function nextSequence(store: OfflineStore): Promise<number> {
  const current = (await store.get<number>('meta', SEQUENCE_KEY)) ?? 0;
  const next = current + 1;
  await store.put('meta', SEQUENCE_KEY, next);
  return next;
}
